import { AccountAddress } from '../../azure-b2c/storage'

export const getUniqueAddresses = (items: AccountAddress[]) => {
  const uniqueItems = new Set()

  return items.filter((e) => {
    if (!e.street) return false

    const isDuplicate = uniqueItems.has(`${e.name}_${e.fullAddress}`)
    uniqueItems.add(`${e.name}_${e.fullAddress}`)
    if (!isDuplicate) {
      return true
    }
    return false
  })
}
